import React, { useState, useEffect, createContext } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "react-checkbox-tree-enhanced/lib/react-checkbox-tree.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Login from "./pages/Login";
import NewLogin from "./pages/Loginnew";
import ForgotPassword from './pages/ForgotPassword';
import SuperAdmin from "./pages/SuperAdmin/SuperAdmin";
import FirmAdmin from "./pages/FirmAdmin/FirmAdmin";
import ThemeSelector from "./themes/ThemeSelectorComponent/ThemeSelector";
import Dashboard from "./pages/NewDashboard/Dashboard";
import ReportDashboard from "./pages/ReportDashboard/ReportDashboard";
import TaskDetailsReport from "./pages/reports/TaskDetailsReport/TaskDetailsReport";
import JurisdictionReport from "./pages/reports/JurisdictionReport/JurisdictionReport";
import StaffingReport from "./pages/reports/StaffingReport/StaffingReport";
import RolesEngagementReport from "./pages/reports/RolesEngagementReport/RolesEngagement";
import BillableReport from "./pages/reports/BillableNonBillableReport/BillableReport";
import VendorDetails from "./pages/vendorDetails";
import CrossReference from "./pages/crossReference";
import MaintanenceReports from "./pages/MaintanenceReports";
import AutomatedReports from "./pages/AutomatedReports";
import DownloadedReports from "./pages/AutomatedReports/DownloadedReports";
import ScheduledReports from "./pages/AutomatedReports/ScheduledReports";
import Intent from "./pages/IntentPage";
import MonthlyTaskStatusReport from "./pages/reports/MonthlyTaskStatusReport/MonthlyTaskStatusReport";
import WorkDistributionReport from "./pages/reports/WorkDistributionReport/WorkDistributionReport";
import ClientOnboarding from "./separate_apps/ClientOnboarding/clientonboarding";
import ClientOnboardingConfigFlow from "./separate_apps/ClientOnboarding/clientonboardingconfigflow";
import TermsOfService from "./pages/terms_of_service/TermsOfService/TermsOfService";

const Configuration = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs={2}></Col>
        <Col xs={10}>
          <h2>Configuration</h2>
        </Col>
      </Row>
    </Container>
  );
};

function App(props) {
  const [basic, setBasic] = useState(false)
  const restrictedUsers = ["wenddev", "ewilder@wendroffcpa.com", "wendprod"];
  const activeFeatures = props.activeFeatures
  // console.log("OS VARIABLE ENV: ", process.env)
  // console.log("BASIC feature: ", basic)
  useEffect(() => {
    if ((activeFeatures != [] && activeFeatures != null) && activeFeatures.includes("Level 1 Support")) {
      setBasic(true)
    }
  }, [activeFeatures])

  return (
    <>
      <Routes>
        <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path={"/login2"} element={<NewLogin />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path="/forgot-password" element={<ForgotPassword />} />
         <Route path={"/"} element=
          {
            basic
            ?
          <ReportDashboard />
            :
          <MaintanenceReports />
          }
          >
          </Route>
        <Route path={""} element=
        {
          basic
          ?
        <ReportDashboard />
          :
        <MaintanenceReports />
        }
        ></Route>
        <Route
          path={"/maintanenceReports"}
          element={<MaintanenceReports />}
        ></Route>{" "}
        : <Route path={"/login"} element={<NewLogin />}></Route>
        <Route path={"/"} element={<ReportDashboard />}></Route>
        <Route path={""} element={<ReportDashboard />}></Route>
        <Route path={"/dashboard"} element={<Dashboard />}></Route>
        <Route
          path={"/maintanenceReports"}
          element={<MaintanenceReports />}
        ></Route>
        <Route path={"/report-dashboard"} element={<ReportDashboard />}></Route>

        <Route
          path={"/automatedReports"}
          element={<AutomatedReports />}
        ></Route>
        <Route
          path={"/report/task_details/"}
          element={<TaskDetailsReport />}
        ></Route>
        <Route
          path={"/report/jurisdictions/"}
          element={<JurisdictionReport />}
        ></Route>
        <Route
          path={"/report/staffing/"}
          element={<StaffingReport />}
        ></Route>
        <Route
          path={"/report/role_engagement/"}
          element={<RolesEngagementReport />}
        ></Route>
        <Route
          path={"/report/billable/"}
          element={<BillableReport />}
        ></Route>
        <Route
          path={"/report/due_date/"}
          element={<MonthlyTaskStatusReport />}
        ></Route>
        <Route
          path={"/report/work_distribution/"}
          element={<WorkDistributionReport />}
        ></Route>
        <Route
          path={"/configuration"}
          element={<Configuration />}
        ></Route>
        <Route
          path={"/intent"}
          element={<Intent />}
        ></Route>
        <Route
          path={"/configuration/vendordetails"}
          element={<VendorDetails />}
        ></Route>
        <Route
          path={"/configuration/mapping"}
          element={<CrossReference />}
        ></Route>
        {/* <Route
          path={"/configuration/firmjobs"}
          element={<FirmJobs />}
        ></Route> */}
        {/* <Route
          path={"/configuration/reports"}
          element={<FirmReports />}
        ></Route> */}
        {/* <Route
          path={"/configuration/manageUsers"}
          element={<ManageUsers />}
        ></Route> */}
        <Route
          path={"/automatedReports/downloadedReports"}
          element={<DownloadedReports />}
        ></Route>
        <Route
          path={"/automatedReports/scheduledReports"}
          element={<ScheduledReports />}
        ></Route>
        <Route path={"/superadmin"} element={<SuperAdmin />}></Route>
        <Route path={"/clients"} element={<ClientOnboarding />}></Route>
        <Route path={"/clientonboarding"} element={<ClientOnboardingConfigFlow />}></Route>
        <Route path={"/firmadmin"} element={<FirmAdmin />}></Route>
        <Route path={"/themes"} element={<ThemeSelector />}></Route>
      </Routes>
    </>
  );
}

export default App;
